import { FC } from 'react'
import BaseWarning from './BaseWarning'

interface SentriKeyWarningProps {
  onClose: () => void
  onConfirm: () => void
  sentrikeyAccountSetupUrl?: string
}

const SentriKeyWarning: FC<SentriKeyWarningProps> = ({
  onClose,
  onConfirm,
  sentrikeyAccountSetupUrl,
}) => {
  return (
    <BaseWarning
      onClose={onClose}
      message={
        <div>
          <p>
            Before you save your preference change, the security information for
            your account with SentriKey Showing Service (SKSS) needs to be
            configured. If you have not already done so, please use this{' '}
            <a
              href={sentrikeyAccountSetupUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              link
            </a>{' '}
            to navigate to SKSS. The site will open in a new tab.
          </p>
          <button onClick={onConfirm} style={{ marginTop: '10px' }}>
            I understand
          </button>
        </div>
      }
      hideCloseButton={true}
    />
  )
}

export default SentriKeyWarning
